var map = {
	"./BaseMarketTabs.vue": "93To",
	"./BaseMarketTabsDashboard.vue": "ATes",
	"./Button.vue": "la1S",
	"./Card.vue": "uU9L",
	"./Checkbox.vue": "XZfp",
	"./Child.vue": "tbOS",
	"./ExchangeTabs.vue": "b9w0",
	"./ExchangeTabsDashboard.vue": "NJ5f"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57QD";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/global nonrecursive .*\.(js|vue)$
// module id = 57QD
// module chunks = 0